import React, { useEffect, useState } from "react";

const VideoStream = ({ templates, templateStyles }) => {
  const [videoSrc, setVideoSrc] = useState(
    templateStyles?.backgroundimage || null
  );

  useEffect(() => {
    const videoTemplate = templates.find(
      (field) => field?.backgroundimage && field?.backgroundimage !== ""
    );
    if (videoTemplate) {
      setVideoSrc(videoTemplate.backgroundimage);
    }
  }, [templates]);

  const isYouTubeUrl = videoSrc && (videoSrc.includes("youtube.com") || videoSrc.includes("youtu.be"));

  return (
    <div className="video-stream" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      {/* {isYouTubeUrl ? (
        <iframe
          width="100%"
          height="315"
          src={videoSrc}
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          // style={{ borderRadius: "8px" }}
        ></iframe>
      ) : (
        <video
          src={
           videoSrc
          }
          autoPlay
          playsInline
          muted
          controls
          loop
          style={{ width: "90%", borderRadius: "8px" }}
        />
      )} */}
      {videoSrc && (
        isYouTubeUrl ? (
          <iframe
            width="100%"
            height="315"
            src={videoSrc}
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          >
          </iframe>
        ) : (
          <video
          src={videoSrc}
          autoPlay
          playsInline
          muted
          controls
          loop
          style={{ width: "90%", borderRadius: "8px" }}
        />
        )
      )}
    </div>
  );
};

export default VideoStream;
